import React from 'react';
import { Container, Typography, Box, Divider, Link } from '@mui/material';
import { images } from '../../../../../shared/lib/assets';

export default function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      {/* Title */}

      <Box display="flex" justifyContent="center" mb={4}>
        <Link href="https://855whodoicall.com" target="_blank" underline="none">
          <Box component="img" src={images.DASHBOARD_LOGO as unknown as string} alt="855WhoDoICall.com" sx={{ height: 60 }} />
        </Link>
      </Box>

      <Typography variant="h4" align="center" fontWeight="700" gutterBottom>
        Privacy Policy
      </Typography>

      <Typography variant="h6" align="center" sx={{ mb: 2, fontWeight: 600 }}>
        855WHODOICALL® PRIVACY POLICY (Effective December 1, 2025).
      </Typography>

      {/* Intro */}
      <Box mb={4}>
        <Typography variant="body1" paragraph>
          855WHODOICALL®, operated by FALLBACK SERVICESTM, LLC, located at 2501 Thornapple River Dr. Grand Rapids Michigan 49546 (“855WHODOICALL®,” “we,” or “our”), recognizes the importance of your
          personal privacy. Therefore, we have created this Privacy Policy so that you know how we use and disclose your information when you make it available to us. The Privacy Policy below
          discloses our practices regarding information collection and usage for the website located at www.855whodoicall.com, the mobile website, and the mobile application called 855WHODOICALL®
          (collectively, the “Service”). Capitalized terms not otherwise defined in this Privacy Policy have the meaning ascribed to them in our Terms of Use at www.855whodoicall.com/terms-of-use.
        </Typography>
        <Typography variant="body1" paragraph>
          By using or accessing the Service, you signify your agreement and consent to be bound by this Privacy Policy. IF YOU DO NOT AGREE TO THIS PRIVACY POLICY YOU MAY NOT ACCESS OR OTHERWISE USE
          OUR SERVICE OR PARTICIPATE IN OUR SERVICES.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Key aspects */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Key aspects of our privacy practices described in this Privacy Policy include the following explanations:
        </Typography>
        <Typography variant="body1" component="div">
          <ul>
            <li>The information we collect and why we collect it;</li>
            <li>How we use that information;</li>
            <li>How we share information; and</li>
            <li>The choices we offer.</li>
          </ul>
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Personally Identifiable Information */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Personally Identifiable Information That We Collect:
        </Typography>
        <Typography variant="body1" paragraph>
          You may be required to submit certain personally identifiable information when you register for the Service. The personally identifiable information which you may provide to us could include
          your email, name, address, telephone number, birth date, gender, payment information, and other personal information.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Contact Opt-Out Process */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Contact Opt-Out Process:
        </Typography>
        <Typography variant="body1" paragraph>
          Contacts added by users to their account have the ability to opt-out of being included in the contact list. If a contact wishes to be removed, they can:
        </Typography>
        <Typography variant="body1" component="div">
          <ul>
            <li>Follow the link provided by 855WHODOICALL® in the automated text and/or email sent by us and select “Opt-Out”</li>
            <li>Contact us directly at Opt-Out@855WHODOICALL.COM.</li>
          </ul>
        </Typography>
        <Typography variant="body1" paragraph>
          Once an opt-out request is received, we will promptly remove the contact from the users contact list.
        </Typography>

        <Typography variant="body1" paragraph>
          To Opt-In again, the Contact must contact us directly by emailing us at Opt- In@855WHODOICALL.com requesting such, including the User Name and Phone Number for the user which they want to be
          added again as a contact.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Choice of Use of App */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Choice of Use of App:
        </Typography>
        <Typography variant="body1" paragraph>
          Users may use the application as an additional toolset to manage their 855WHODOICALL.com account. 855WhoDoICall.com provides a trusted calling service that allows its users to place a call
          to 855WhoDoICall (855) 946-3342 and through that call, they can place a call to any of their Trusted Contacts that they have saved within their VIP contact list.
        </Typography>
        <Typography variant="body1" paragraph>
          Managing their account includes but is not limited to the following:
        </Typography>
        <Typography variant="body1" component="div">
          <ul>
            <li>Make calling plan changes</li>
            <li>Update Billing information</li>
            <li>Update Contact information</li>
            <li>Update Account Details</li>
            <li>Cancel Services and Delete their account</li>
            <li>Review Calling Logs</li>
            <li>Review Ring My Phone (RMP) logs</li>
            <li>Update/Customize the RMP messaging services</li>
          </ul>
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Geo-Location */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Geo-Location Information:
        </Typography>
        <Typography variant="body1" paragraph>
          When you access or use the Service, 855WHODOICALL® may access, collect, monitor and/or remotely store “location data,” which may include GPS coordinates (including, but not limited to,
          latitude and/or longitude), IP addresses, and/or similar information regarding the actual location of your device. The Ring My Phone (RMP) technology may allow you to locate your device by
          viewing the location of the device in your Secure User Portal. Location data may also convey to us information about how you browse or use the Service. Location data that we collect
          internally does not contain any personally identifiable information about you. Location data may be used in conjunction with personally identifiable information to locate your device.
        </Typography>
        <Typography variant="body1" paragraph>
          855WHODOICALL® may store, use, and share this information as authorized by this Privacy Policy.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Protection for EU */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Protection for European Union Citizens:
        </Typography>
        <Typography variant="body1" paragraph>
          If you are a resident of the European Union, you acknowledge and agree that you must email us at info@855WHODOICALL.com before using the Service. If you do not notify us prior to your use of
          the Service, you acknowledge and agree that 855WHODOICALL® shall not be liable for any damages whatsoever, whether direct, indirect, general, special, compensatory, consequential, and/or
          incidental, arising out of or relating to any European Union law or regulation, including without limitation the General Data Protection Regulation.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Non-Personal/Aggregate Information */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Non-Personal Or Aggregate Information That We Collect:
        </Typography>
        <Typography variant="body1" paragraph>
          When you access our Service, we may automatically collect non-personally identifiable information from you, such as IP host address, web pages viewed, browser type, operating system,
          referring service, search information, device type, page views, usage and browsing habits on the Service and similar data. We may also aggregate demographic information collected from our
          users (such as the number of users in a particular geographical location) in a manner which does not identify any one individual. We may also aggregate information collected offline in
          connection with the Service, obtain non-personally identifiable information from third party sources and develop aggregate information by anonymizing previously collected personally
          identifiable information.
        </Typography>
        <Typography variant="body1" paragraph>
          It is possible at times when collecting non-personally identifiable information through automatic means that we may unintentionally collect or receive personally identifiable information
          that is mixed in with the non-personally identifiable information. While we will make reasonable efforts to prevent such incidental data collection, the possibility still exists and we shall
          have no liability for such incidental data collection. If you believe that we have inadvertently collected your personal information, please notify us at info@855WHODOICALL.com.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Information Usage */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Information Usage:
        </Typography>
        <Typography variant="body1" paragraph>
          We will only use your personally identifiable information as described below, unless you have specifically consented to another type of use, either at the time the personally identifiable
          information is collected from you or through some other form of consent from you or notification to you:
        </Typography>
        <Typography variant="body1" component="div">
          <ul>
            <li>We may share your personally identifiable information collected in connection with providing the Service.</li>
            <li>We may use your personally identifiable information to respond to your inquiries or requests.</li>
            <li>
              We may use your personally identifiable information to send you emails and/or text messages from time to time about our services, but we will not provide your personally identifiable
              information to third parties for them to contact you directly unless otherwise permitted by this Privacy Policy or upon your consent. You give 855WHODOICALL® consent to provide your
              mobile telephone number to your Contacts with whom you’ve been connected via the Service.
            </li>
            <li>
              We may share your personally identifiable information with third parties to further the purpose for which you provided such information to us (collectively, the “Third Party Vendors”).
              We will share such information with the following Third Party Vendors: InSight CCM, LLC, Stripe INC, Twilio INC.
            </li>
            <li>
              We urge you to read the privacy practices of all of our Third Party Vendors before submitting any personally identifiable information through the Service. You acknowledge and agree that
              you are solely responsible for ensuring that you comply with the Terms of Use and Privacy Policies of Third Party Vendors.
            </li>
            <li>We may disclose personally identifiable information as required by law or legal process.</li>
            <li>
              We may disclose personally identifiable information to investigate suspected fraud, harassment or other violations of any law, rule or regulation, or the terms or policies for our
              services or our sponsors.
            </li>
            <li>
              We may transfer your personally identifiable information in connection with the sale, merger, or change of control of 855WHODOICALL® or the division responsible for the services with
              which your personally identifiable information is associated.
            </li>
            <li>
              We may transfer your personally identifiable information in connection with the sale, merger, or change of control of 855WHODOICALL® or the division responsible for the services with
              which your personally identifiable information is associated.
            </li>
            <li>
              Non-personally identifiable or aggregate information may be used by us for any purposes permitted by law and may be shared with any number of parties, provided that such information
              shall not specifically identify you.
            </li>
          </ul>
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Cookies & Similar Technologies */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Cookies and Similar Technologies:
        </Typography>
        <Typography variant="body1" paragraph>
          Cookies” are pieces of information that may be placed on your computer or device by a service for the purpose of facilitating and enhancing your communication and interaction with that
          service. Many services use cookies for these purposes. We may use cookies (and similar items such as clear gifs, web beacons, tags, etc.) on our Service to customize your visit and for other
          purposes to make your visit more convenient or to enable us to enhance our Service. We may also use and place cookies (and similar items) on your computer or device from our third party
          service providers in connection with the Service, such as an analytics provider that helps us manage and analyze Service usage, as described more fully below. In addition, our advertisers
          and business partners may set cookies and similar items on your computer or device when you use our Service. You may stop or restrict the placement of cookies on your computer or device or
          flush them from your browser by adjusting your web browser preferences, in which case you may still use our Service, but it may interfere with some of the Service’s functionality. Cookies
          and similar items are not used by us to automatically retrieve personally identifiable information from your computer or device without your knowledge
        </Typography>
        <Typography variant="body1" paragraph>
          If you delete your cookies, change browsers or use a different cookie, our cookie (or an opt-out cookie) may no longer work and you may have to reinput (or opt-out) again.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Automatically Collected Info */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Automatically Collected Information:
        </Typography>
        <Typography variant="body1" paragraph>
          When you access the Service or open one of our HTML emails, we may automatically record certain information from your system by using cookies and other types of tracking technologies. This
          “automatically collected” information may include an Internet Protocol address (“IP Address”), a unique user ID, device type, device identifiers, browser types and language, referring and
          exit pages, platform type, version of software installed, system type, the content and pages that you access on the Service, the number of clicks, the amount of time spent on pages, the
          dates and times that you visit the Service, and other similar information. Depending on the law of your country of residence, your IP address may legally be considered personally
          identifiable information.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Analytics & Conversion Tracking */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Analytics and Conversion Tracking:
        </Typography>
        <Typography variant="body1" paragraph>
          We may use analytics services that use cookies, JavaScript and similar technologies to help us analyze how users use the Service. The information generated by these services about your use
          of the Service (including your IP address or a truncated version of your IP address) is transmitted to and stored by analytics service providers on their servers. Those service providers
          will use this information for the purpose of evaluating your, and other users’, use of the Service, compiling reports for us on website and mobile activity and providing other services
          relating to website or mobile activity and Internet usage.
        </Typography>
        <Typography variant="body1" paragraph>
          We may collect information about your computer or device, including your IP address, operating system, and browser type, for system administration and in order to create reports. This is
          statistical data about our users’ browsing actions and patterns, and does not identify any individual.
        </Typography>
        <Typography variant="body1" paragraph>
          We may use cookies on our site for Google Analytics. Google Analytics is a web analytics tool that helps website owners understand how visitors engage with their website. Google Analytics
          customers can view a variety of reports about how visitors interact with their website so that they can improve it.
        </Typography>
        <Typography variant="body1" paragraph>
          Like many services, Google Analytics uses first-party cookies to track visitor interactions as in our case, where they are used to collect information about how visitors use our site. We may
          then use the information to compile reports and to help us improve our site.
        </Typography>
        <Typography variant="body1" paragraph>
          Cookies contain information that is transferred to your computer’s or other device’s hard drive. These cookies are used to store information, such as the time that the current visit
          occurred, whether the visitor has been to the site before, and what site referred the visitor to the web page.
        </Typography>
        <Typography variant="body1" paragraph>
          Google Analytics collects information anonymously. It reports website trends without identifying individual visitors. You can opt out of Google Analytics without affecting how you visit our
          site. For more information on opting out of being tracked by Google Analytics across all websites you use, visit https://tools.google.com/dlpage/gaoptout.
        </Typography>
        <Typography variant="body1" paragraph>
          We also use Google conversion tracking and/or similar services to help us understand your and other users’ use of the Service. Please see this article on Google conversion tracking for more
          information.
        </Typography>
        <Typography variant="body1" paragraph>
          Some Internet browsers provide the ability to communicate that the user does not wish to be tracked while browsing. We currently do not have the ability to respond to such “Do Not Track”
          signals.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Security */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Security:
        </Typography>
        <Typography variant="body1" paragraph>
          The security of your personally identifiable information is very important to us. When we collect your personally identifiable information online, we use reasonable efforts to protect it
          from unauthorized access. However, due to the inherent open nature of the Internet, we cannot guarantee that your personally identifiable information will be completely free from
          unauthorized access by third parties such as hackers, and by your use of our Service, you agree to expressly assume this risk. We have put in place reasonable physical, electronic, and
          managerial procedures to safeguard the information we collect. Only those employees who need access to your information in order to perform their duties are authorized to have access to your
          personally identifiable information. For more information on protecting your privacy, please visit www.ftc.gov/privacy.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Disclosures in Blogs & Social Media */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Your Disclosures In Blogs And Other Social Media:
        </Typography>
        <Typography variant="body1" paragraph>
          You should be aware that personally identifiable information which you voluntarily include and transmit online on the Service or in a publicly accessible blog, chat room, social media
          platform or otherwise online, or that you share in an open forum such as an in-person panel or survey, may be viewed and used by others without any restrictions. We are unable to control
          such uses of your personally identifiable information, and by using the Service or any other online services, you assume the risk that the personally identifiable information provided by you
          may be viewed and used by third parties for any number of purposes.
        </Typography>
        <Typography variant="body1" paragraph>
          If you connect to a third party service such as, for example, Facebook or Twitter (collectively, the “Third Party Services”) through an icon or link on the Service or otherwise link your
          855WHODOICALL® account with a Third Party Service, we may share the contents of such post and associated information (such as your user name, the fact that your connection originated from
          the Service, and other relevant usage and diagnostic information) with such third party. With your one-time consent, we may also send information about the content you prospectively watch
          and your prospective activities on the Service to such third parties. Once such information is shared, the use of your information will be subject to that service’s privacy policy and this
          Privacy Policy will not apply.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Protection for Children */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Protection for Children:
        </Typography>
        <Typography variant="body1" paragraph>
          We will not knowingly collect any personally identifiable information from children seventeen (17) years of age or younger. When you disclose personally identifiable information on the
          855WHODOICALL® Service, you are representing to us that you are eighteen (18) years of age or older. If a person seventeen (17) years of age or younger has provided personally identifiable
          information to us, a parent or guardian should contact us at privacy@855WHODOICALL.com so that we can remove such personally identifiable information from our active databases.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Other Services */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Other Services:
        </Typography>
        <Typography variant="body1" paragraph>
          As a convenience to you, we may provide links to third-party services from within our Service. We are not responsible for the privacy practices or content of these third- party sites. When
          you link away from our Service, you do so at your own risk.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Limits on Our Abilities */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Limits on Our Abilities:
        </Typography>
        <Typography variant="body1" paragraph>
          Your privacy is very important to us. However, due to the existing legal and technical environment, we cannot ensure that your personally identifiable information will not be disclosed to
          third parties in ways not described in this Privacy Policy. For example, we may be forced to disclose information to the government or third parties under certain circumstances, or third
          parties may unlawfully intercept or access transmissions or private communications. Additionally, we can (and you authorize us to) disclose any information about you to private entities, law
          enforcement or other government officials that we, in our sole discretion, believe is required: (a) by law; (b) to protect and/or defend our property or other legal rights; and/or (c) to
          protect the personal safety, or property or other legal rights of others.
        </Typography>
        <Typography variant="body1" paragraph>
          In any event, we cannot and do not guarantee that our franchisees, licensees, co- branding partners or other independently owned and operated centers will follow the terms of this Privacy
          Policy. Therefore, if you provide information to any of these parties, such information will not be subject to the terms of this Privacy Policy. In addition, in the event that all or
          substantially all of our membership interest and/or assets are transferred or sold to another entity, we have the right to transfer personally identifiable information and non-personally
          identifiable information to the acquiring entity.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Changes to Policy */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Changes to this Privacy Policy:
        </Typography>
        <Typography variant="body1" paragraph>
          We reserve the right, at our discretion, to change, modify, add, or remove portions from this Privacy Policy at any time. However, if at any time in the future we plan to use personally
          identifiable information in a way that materially differs from this Privacy Policy, including sharing such information with more third parties, we will (a) post such changes here, (b) post a
          notice of such changes to the Service, and (c) send an email to your email address on file. Your continued use of the Service and our services following the posting of any changes to this
          Privacy Policy shall constitute your consent to such changes.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Opt-Out Process */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Opt-Out Process:
        </Typography>
        <Typography variant="body1" paragraph>
          All unsubscribe or opt-out requests may be made by clicking the “unsubscribe” link at the bottom of the email or by emailing us at info@855WHODOICALL.com. We will process your request within
          a reasonable time after receipt. However, we are not responsible for, and in some cases we are incapable of, removing your personally identifiable information from the lists of any third
          party who has previously been provided your information in accordance with this Privacy Policy or your consent. You should contact such third parties directly to have such personally
          identifiable information removed. If you would like to update or correct any personally identifiable information that you have provided to us, please email us at info@855WHODOICALL.com and
          once we confirm your information, we will update such information within a reasonable amount of time.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Controlling or Changing Info */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Controlling or Changing Your Information:
        </Typography>
        <Typography variant="body1" paragraph>
          You may review, change, or request the deletion of your Personal Information and preferences at any time by contacting us at privacy@855WHODOICALL.com. We will then take all reasonable
          efforts to correct or remove your personally identifiable information from our active database.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Communications */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Communications with 855WHODOICALL®:
        </Typography>
        <Typography variant="body1" paragraph>
          By providing your contact information including but not limited to your email address and phone number (collectively the “Channels”) to us, you expressly consent to receive communications
          from us. We may use the Channels to communicate with you, to send information that you have requested or to send information about other products or services developed or provided by us or
          our business partners, provided that, we will not give your contact information to another party to promote their products or services to you without your consent or as set forth in this
          Privacy Policy.
        </Typography>
        <Typography variant="body1" paragraph>
          By providing your phone number to us, you expressly consent to receive phone calls and/or text messages from us and/or from a Contact (as that term is defined in the Terms of Use). We will
          not give your phone number to another party to promote their products or services to you without your consent or as set forth in this Privacy Policy.
        </Typography>
        <Typography variant="body1" paragraph>
          Any phone calls and/or text messages delivered to your phone or device may cause you to incur extra data, text messaging, or other charges from your wireless carrier. MESSAGE AND DATA RATES
          MAY APPLY. You are solely responsible for any carrier charges incurred as a result of phone and/or text communications from 855WHODOICALL®.
        </Typography>
        <Typography variant="body1" paragraph>
          By using the mobile application, you explicitly consent to receive in-app notifications, or push notifications.
        </Typography>
        <Typography variant="body1" paragraph>
          Any communication or material you transmit to us by email or otherwise, including any data, questions, comments, suggestions, or the like is, and will be treated as, non- confidential and
          nonproprietary. Except to the extent expressly covered by this Privacy Policy, anything you transmit or post may be used by us for any purpose, including but not limited to, reproduction,
          disclosure, transmission, publication, broadcast and posting. Furthermore, you expressly agree that we are free to use any ideas, concepts, know-how, or techniques contained in any
          communication you send to us, as well as any data developed using the content of such communication, without compensation and for any purpose whatsoever, including but not limited to,
          developing, manufacturing and marketing products and services using such information.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* No Rights of Third Parties */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          No Rights of Third Parties:
        </Typography>
        <Typography variant="body1" paragraph>
          This Privacy Policy does not create rights enforceable by third parties.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Site Terms of Use */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Site Terms of Use:
        </Typography>
        <Typography variant="body1" paragraph>
          Use of this Service is governed by, and subject to, the Terms of Use located at 855WHODOICALL.com/terms-of-use (the “Terms”). This Privacy Policy is incorporated into the Terms. Your use, or
          access, of the Service constitutes your agreement to be bound by these provisions. IF YOU DO NOT AGREE TO THE TERMS AND THIS PRIVACY POLICY YOU MAY NOT ACCESS OR OTHERWISE USE THE SERVICE.
        </Typography>
        <Typography variant="body1" paragraph>
          IN THE EVENT OF ANY INCONSISTENCY OR CONFLICT BETWEEN THIS AGREEMENT AND THE TERMS, THE FOLLOWING ORDER OF PRECEDENCE SHALL CONTROL: (A) THE TERMS; AND (B) THIS AGREEMENT.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Servers */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Servers:
        </Typography>
        <Typography variant="body1" paragraph>
          Our servers are maintained in the United States of America; we may also maintain servers in other countries (collectively, the “Server Countries”). By using the Service, you freely and specifically
          give us your consent to export your personally identifiable information to the Server Countries and to store and use it in the Server Countries as specified in this Privacy Policy. You
          understand that data stored in the Server Countries may be subject to lawful requests by the courts or law enforcement authorities in the Server Countries.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Governing Law */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Governing Law:
        </Typography>
        <Typography variant="body1" paragraph>
          This Privacy Policy and our legal obligations hereunder are subject to the laws of Michigan, USA, regardless of your location. You hereby consent to the exclusive jurisdiction of and venue
          in the courts located in Kent County, Michigan, USA, in all disputes arising out of or relating to the Service.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Your California Privacy Rights */}
      <Box mb={4}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Your California Privacy Rights:
        </Typography>
        <Typography variant="body1" paragraph>
          California Civil Code Section 1798.83 permits users of our Service that are California residents to request certain information regarding our disclosure of personally identifiable
          information to third parties for their direct marketing purposes. To make such a request, please send an email to info@855WHODOICALL.com.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Contact */}
      <Box mb={2}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Contact:
        </Typography>
        <Typography variant="body1">For questions or concerns relating to privacy, we can be contacted at info@855WHODOICALL.com.</Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Typography variant="body2" color="text.secondary" align="center">
        FALLBACK SERVICESTM, LLC — 2501 Thornapple River Dr., Grand Rapids, MI 49546
      </Typography>
    </Container>
  );
}
